
import csstype.ClassName
import react.FC
import react.Props
import react.dom.html.ReactHTML
import react.dom.html.ReactHTML.a
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.h1
import react.dom.html.ReactHTML.img
import react.dom.html.ReactHTML.p
import react.useState

val Welcome = FC<Props> {
    var careState by useState<CareState>(object : CareState {
        override var stoneType = "granite"
    })

    HeaderComponent()

    div {
        id = "aboutUs"
        h1 {
            +"About us"
        }
        p {
            +"""
                ASPAC GRANITE Ltd. is based in the mainland Fraser valley of the Vancouver area in 
                beautiful British Columbia. With the amalgamation of extensive stone work experience
                and business acumen, ASPAC GRANITE was created with a view to service the Granite/Marble/Quartz 
                countertops need of a growing multifamily market ,and, 
                the needs of single-family home customers who have a busy schedule and lifestyle.
            """.trimIndent()
        }
    }

    div {
        id = "caring"
        h1 {
            +"""How to Care your 
                ${
                when (careState.stoneType) {
                    "granite", "marble", "limestone", "quartz" -> careState.stoneType
                    else -> "..."
                }
            }"""
        }

        when (careState.stoneType) {
            "granite", "marble", "limestone", "quartz" -> CareDiv { stoneType = careState.stoneType }
            else -> null
        }

        div {
            className = ClassName("row")
            AsPacStoneType.values().forEach { stone ->
                button {
                    onClick = {
                        careState = object : CareState {
                            override var stoneType = stone.stoneName
                        }
                    }
                    className = ClassName("columnfour")
                    if (stone.stoneName == careState.stoneType)
                        hidden = true
                    else
                        +stone.stoneName.replaceFirstChar { it.uppercase() }
                }
            }
        }
    }

    div {
        id = "samplesList"
        h1 {
            +"Check out our samples"
        }
        div {
            className = ClassName("row")
            AsPacStoneType.values().forEach { stone ->
                div {
                    className = ClassName("columnfour")
                    img {
                        src = "images/${stone.stoneName}.jpg"
                    }
                }
            }
        }
        div {
            className = ClassName("row")
            AsPacStoneType.values().forEach { stone ->
                div {
                    className = ClassName("columnfour")
                    a {
                        href = "granitecolors.html?stype=${stone.stoneName}"
                        +"${stone.stoneName.replaceFirstChar { it.uppercase() }} Sample"
                    }
                }
            }
        }
    }

    div {
        id = "contactus"
        h1 {
            + "Contact Us"
        }
        ReactHTML.table {
            ReactHTML.tr {
                ReactHTML.th {
                    +"Location"
                }
                ReactHTML.td {
                    +"""
                            Unit 148 - 11860 Hammersmith Way,
                            Richmond, BC, 
                            Canada
                        """.trimIndent()
                }
            }
            ReactHTML.tr {
                ReactHTML.th {
                    +"Email"
                }
                ReactHTML.td {
                    +"info@aspacgranite.com"
                }
            }
            ReactHTML.tr {
                ReactHTML.th {
                    +"Phone Number"
                }
                ReactHTML.td {
                    +"778-892-2397"
                }
            }
        }
    }
}

